import type { NetworkPayload } from "../../../composites";

export const API = {
  fetchSurveys: (): NetworkPayload => {
    return {
      url: `surveys/`,
      options: {
        method: "GET",
      },
    };
  },
  recordImpression: ({
    survey_uuid,
  }: API.NPS.RecordImpression.Request): NetworkPayload => {
    return {
      url: `survey_impressions/`,
      options: {
        method: "POST",
        payload: {
          survey: survey_uuid,
        },
      },
    };
  },
  submitAnswer: ({
    impression_uuid,
    question_uuid,
    value,
  }: API.NPS.SubmitAnswers.Request): NetworkPayload => {
    return {
      url: `survey_impressions/create_answer/`,
      options: {
        method: "POST",
        payload: {
          impression_uuid,
          question_uuid,
          value,
        },
      },
    };
  },
};
